export const SERVICE = {
  DEVICE_CHANGE: 'DEVICE_CHANGE',
  REMOTE_CONFIGURATION_DEVICE_CHANGE: 'REMOTE_CONFIGURATION_DEVICE_CHANGE',
  SUBSCRIPTION_PAYMENT: 'SUBSCRIPTION_PAYMENT',
};
